module.exports = __webpack_public_path__ + "static/media/siswa_keluar.0e58a43d.png";